module.exports = __webpack_public_path__ + "img/enterprise-institution-4.a0eccf06.png";